import React, { useCallback, FC } from 'react'
import FileInput from '../../filestore/FileInput'

import {
  FormFieldProps,
} from '../../../types/form'

import {
  IField_Storage_File,
} from '@kaidam/fc-shared/src/types/storage'

import {
  getFilestoreTypeAccessType,
} from '@kaidam/fc-shared/src/utils/storage'

import {
  STORAGE_LOCATIONS,
  STORAGE_ACCESS_TYPE_PUBLIC,
  STORAGE_ACCESS_TYPE_SHARED,
} from '@kaidam/fc-shared/src/constants'

const FileField: FC<React.PropsWithChildren<FormFieldProps>> = ({
  field: {
    name,
    value,
  },
  form: {
    setFieldValue,
  },
  item,
  readonly,
}) => {
  const storage_location = item.meta?.location as string

  if(!storage_location) {
    console.error(item)
    throw new Error(`there is a form schema with an old style file field -> meta.location required for file field`)
  }
  if(!STORAGE_LOCATIONS[storage_location]) {
    console.error(item)
    throw new Error(`form schema with no known storage location ${storage_location}`)
  }

  const location = STORAGE_LOCATIONS[storage_location]

  const chooserActive = typeof(item.meta?.chooser) == 'boolean' ? item.meta?.chooser : true
  const chooserDisplayFilter = item.meta?.chooserDisplayFilter || []
  const chooserSelectFilter = item.meta?.chooserSelectFilter || []
  const useTextButtons = item.meta?.useTextButtons || false

  const accessType = getFilestoreTypeAccessType(location.type)

  const publicMode = accessType == STORAGE_ACCESS_TYPE_PUBLIC
  const sharedMode = accessType == STORAGE_ACCESS_TYPE_SHARED

  const onChooseFile = useCallback((file: IField_Storage_File) => {
    setFieldValue(name, file)
  }, [
    name,
  ])

  return (
    <FileInput
      value={ value }
      location={ location }
      chooserActive={ chooserActive }
      displayTypes={ chooserDisplayFilter }
      selectTypes={ chooserSelectFilter }
      accept={ item.meta?.accept }
      readonly={ readonly }
      noReset={ item.meta?.noReset }
      publicMode={ publicMode }
      sharedMode={ sharedMode }
      title={ item.title || item.id }
      helperText={ item.helperText }
      useTextButtons={ useTextButtons }
      onChange={ onChooseFile }
    />
  )
}

export default FileField
